import * as Styled from "./FilledIconButton.styled"

export function FilledIconButton(props) {

    const {
        color,
        size,
        ...otherProps
    } = props

    return <Styled.FilledIconButton color={color} size={size} {...otherProps} />
}

FilledIconButton.defaultProps = {
    color: "primary",
    size: "medium",
}

FilledIconButton.propTypes = {
    ...Styled.FilledIconButton.propTypes,
}